import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Token } from './models/token.model';
import { UserTypes } from '../../auth/enums/user-type.enum';
import { UserProfile } from '../models/user-profile.model';
import { AccessTypes } from '../../auth/enums/access-types.enum';
import { environment } from 'src/environments/environment';
@Injectable()
export class SecurityService {
  public user: UserProfile;

  constructor(private _http: HttpClient, private router: Router) { }

  isAuthenticated(): boolean {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      return true;
    } else {
      return false;
    }
  }

  public getToken(): Token {
    return <Token>JSON.parse(localStorage.getItem('jwtToken'));
  }

  setToken(token: Token): void {
    localStorage.setItem('jwtToken', JSON.stringify(token));
  }

  getUserType(): UserTypes {
    const token = <Token>JSON.parse(localStorage.getItem('jwtToken'));
    if (token.isStaff) {
      return UserTypes.staff;
    } else if (token.isExternalUser) {
      return UserTypes.externalUser;
    } else {
      return UserTypes.petOwner;
    }
  }

  logout(): void {
    const token = this.getToken();
    localStorage.removeItem('jwtToken');
    this.router.navigateByUrl('/auth/login');
  }

  getCurretnLoggedInUserProfile(): UserProfile {
    return <UserProfile>JSON.parse(localStorage.getItem('user'));
  }

  setCurrentLoggedInUser(): void {
    this._http.get(`api/account/getuserprofile`).pipe(
      map((res) => <UserProfile>res)
    ).subscribe((user) => {
      localStorage.setItem('user', JSON.stringify(user));
    });
  }

  hasAccessToRegistrationFormInExternal(): boolean {
    const token = this.getToken();
    if (token) {
      if (token.userType === AccessTypes.implanter ||
        token.userType === AccessTypes.welfare ||
        token.userType === AccessTypes.council ||
        token.userType === AccessTypes.breeder ||
        token.userType === AccessTypes.vet) {
        return true;
      }
    }
    return false;
  }

  hasAccessToSearchMicrochipInExternal(): boolean {
    const token = this.getToken();
    if (token) {
      if (token.userType === AccessTypes.council ||
        token.userType === AccessTypes.registery ||
        token.userType === AccessTypes.vet) {
        return true;
      }
    }
    return false;
  }

  checkIfLoggedUser() {
    const token = this.getToken();
    if (token) {
      if (token.isStaff) {
        this.router.navigateByUrl('/staff/dashboard');
      } else if (token.isExternalUser) {
        if (this.hasAccessToRegistrationFormInExternal()) {
          this.router.navigateByUrl('/external/registration/form');
        } else if (this.hasAccessToSearchMicrochipInExternal()) {
          this.router.navigateByUrl('/external/searchmicro');
        } else {
          this.router.navigateByUrl('/external');
        }
      } else {
        this.router.navigateByUrl('/owner');
      }
    }
  }

}
